import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import { isApiResponse } from '../helpers/utils.js';
import TicketDetailTable from './TicketDetailTable.jsx';
import './TicketReport.css';

class ServiceAgentPerProductTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedProduct: null,
      selectedAgent: null,
      selectedColumnType: null
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_service_agent_performance_product();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
      this.get_filtered_service_agent_performance_product();
    } else if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.chainID !== this.props.chainID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.issue_type !== this.props.issue_type ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team ||
      prevProps.team_member !== this.props.team_member
    ) {
      this.get_filtered_service_agent_performance_product();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#ProductTable')) {
      $('#ProductTable').DataTable().clear().destroy();
    }
  }

  get_filtered_service_agent_performance_product() {
    var that = this;
    if (this.props.shouldLoadData) {
      const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        team_member: this.props.team_member || [],
        group_by: 'product',
        report_code: 'service_agent_performance_product_wise',
        download: 0
      };

      isApiResponse(false);

      if ($.fn.DataTable.isDataTable('#ProductTable')) {
        $('#ProductTable').DataTable().clear().destroy();
      }

      $('#ProductTable').DataTable({
        order: [],
        processing: true,
        serverSide: true,
        bDestroy: true,
        paging: true,
        pageLength: 5,
        bInfo: false,
        sPaginationType: 'simple_numbers',
        autoWidth: true,
        responsive: false,
        searching: true,
        lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
        ajax: {
          url: config.get('API_URL') + '/ServiceReport/service_agent_performance',
          type: 'POST',
          data: postData,
          dataSrc: function (json) {
            isApiResponse(true);
            that.setState({ isChange: false });
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader('Authorization', localStorage.usertoken);
          },
          error: function (data) {
            isApiResponse(true);
            alert('Failed to load data. Please try again');
            console.log('error', data);
          },
          complete: function (data) {
            isApiResponse(true);
          }
        },
        columns: [
          { data: 'Product Name', width: '150px' },
          { data: 'Agent Name', width: '120px' },
          { data: 'Within TAT - No Of Tickets Resolved', width: '100px', className: 'text-center' },
          { data: 'Within TAT - No Of Tickets QC Closed', width: '120px', className: 'text-center' },
          { data: 'Outside TAT - No Of Tickets Resolved', width: '100px', className: 'text-center' },
          { data: 'Outside TAT - No Of Tickets QC Closed', width: '120px', className: 'text-center' },
          { data: '% Tickets Resolved Within TAT', width: '100px', className: 'text-center' },
          { data: '% Tickets QC Closed Within TAT', width: '120px', className: 'text-center' },
          { data: 'Tickets Reopened by QC', width: '100px', className: 'text-center' },
          { data: '% of Tickets Reopened by QC', width: '120px', className: 'text-center' },
          { data: 'Actual Work Hours Spent', width: '120px', className: 'text-center' },
          { data: 'Productivity', width: '100px', className: 'text-center' },
          { data: 'Cost/Ticket', width: '100px', className: 'text-center' }
        ],
        columnDefs: [
          {
            targets: 0,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-150'>${val}</div>`;
            }
          },
          {
            targets: 1,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap'>${val}</div>`;
            }
          },
          {
            targets: [2, 3, 4, 5, 8, 9],
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          },
          {
            targets: [6, 7, 9],
            render: function (data) {
              return data == null ? '0%' : data + '%';
            }
          },
          {
            targets: [10],
            render: function (data) {
              return data == null ? '0.00' : parseFloat(data).toFixed(2);
            }
          },
          {
            targets: [11],
            render: function (data) {
              const val = data == null ? '0.00' : parseFloat(data).toFixed(2);
              return `<strong>${val}</strong>`;
            }
          }
        ]
      });
    }
  }

  handleCellClick(rowData, colIndex) {
    const productName = rowData['Product Name'];
    const agentName = rowData['Agent Name'];
    const columnTypeMap = {
      2: 'resolved_within_tat',
      3: 'qc_closed_within_tat',
      4: 'resolved_outside_tat',
      5: 'qc_closed_outside_tat',
      8: 'repeat_tickets',
      9: 'repeat_tickets'
    };
    const columnType = columnTypeMap[colIndex];
    if (columnType) {
      this.setState({
        showDetails: true,
        selectedProduct: productName,
        selectedAgent: agentName,
        selectedColumnType: columnType
      });
    }
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedProduct: null,
      selectedAgent: null,
      selectedColumnType: null
    });
  }

  render() {
    const { showDetails, selectedProduct, selectedAgent, selectedColumnType } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width marginTop0">
          <table id="ProductTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th rowSpan="2" className="merchant-header-default">Product Name</th>
                <th rowSpan="2" className="merchant-header-default">Agent Name</th>
                <th colSpan="2" className="merchant-header-default text-center">Within TAT</th>
                <th colSpan="2" className="merchant-header-default text-center">Outside TAT</th>
                <th colSpan="7" className="merchant-header-default text-center">Performance</th>
              </tr>
              <tr>
                <th className="merchant-header-default text-center">No. Of Tickets Resolved</th>
                <th className="merchant-header-default text-center">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default text-center">No. Of Tickets Resolved</th>
                <th className="merchant-header-default text-center">No. Of Tickets QC Closed</th>
                <th className="merchant-header-default text-center">% Tickets Resolved Within TAT</th>
                <th className="merchant-header-default text-center">% Tickets QC Closed Within TAT</th>
                <th className="merchant-header-default text-center">Tickets Reopened by QC</th>
                <th className="merchant-header-default text-center">% of Tickets Reopened by QC</th>
                <th className="merchant-header-default text-center">Actual Work Hours Spent</th>
                <th className="merchant-header-default text-center">Productivity</th>
                <th className="merchant-header-default text-center">Cost/Ticket</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>

        {showDetails && (
          <TicketDetailTable
            key={`${selectedProduct}-${selectedAgent}-${selectedColumnType}`}
            tableId="serviceProductDetailsTable"
            apiUrl="/ServiceReport/service_agent_performance_details"
            postData={{
              start_date: this.props.yestSend,
              end_date: this.props.todSend,
              download: 0,
              group_by: 'product',
              group_value: selectedProduct,
              agent_name: selectedAgent,
              column_type: selectedColumnType,
              merchant: this.props.merchantID || [],
              store: this.props.storeID || [],
              issue_category: this.props.cf_issue_sub_category || [],
              city: this.props.city || [],
              channel: this.props.channel || [],
              product: this.props.product || [],
              team: this.props.team || [],
              team_member: this.props.team_member || []
            }}
            title={`Ticket Details - ${selectedProduct} / ${selectedAgent}`}
            columnType={selectedColumnType}
            objectType={this.props.object_type}
            onClose={() => this.closeDetails()}
            downloadConfig={{
              fn: 'service_agent_performance_product_details.csv.gz',
              url: '/service_reports/service_agent_performance_details',
              filters: {
                start_date: this.props.yestSend,
                end_date: this.props.todSend,
                download: 1,
                report_code: 'service_agent_performance_product_wise_details',
                group_by: 'product',
                group_value: selectedProduct,
                agent_name: selectedAgent,
                column_type: selectedColumnType,
                merchant: this.props.merchantID,
                store: this.props.storeID,
                issue_category: this.props.cf_issue_sub_category,
                city: this.props.city,
                channel: this.props.channel,
                product: this.props.product,
                team: this.props.team,
                team_member: this.props.team_member
              },
              timeout: 180
            }}
          />
        )}
      </div>
    );
  }
}

export default ServiceAgentPerProductTab;
